<template>
  <v-layout row wrap>
    <v-flex xs12 sm12 md12>
      <v-toolbar class="primary white--text">
        <v-flex xs2>
          <h2 class="headline font-weight-light">SMS Book</h2>
        </v-flex>
        <v-flex xs2>
            <v-switch
                v-model="selectAll"
                class="white-switch"
                :label="`${!selectAll ? 'Select All' : 'Unselect All'}`"
                @change="toggleSelect()"
            ></v-switch>
        </v-flex>
         <v-spacer></v-spacer>
         <v-flex xs2>
          <v-btn @click="dialog=true" class="primary--text subheading font-weight-bold" style="text-align: center;"> 
            Compose SMS
          </v-btn>
        </v-flex>
        <!-- <router-link to="/Dashboard">
          <v-btn icon>
            <v-icon class="white--text">close</v-icon>
          </v-btn>
        </router-link> -->
      </v-toolbar>

      <!-- firm and Date filter -->
      <!-- End of Firm and Date Filter -->

      <v-layout row wrap>
        <v-flex xs12>
          <v-data-table :headers="buyerHeader" :items="getBuyers" hide-actions class="elevation-1 dashboardHead">
            <template slot="items" slot-scope="props">
              <template>
                <td>
                    <v-checkbox
                        v-model="props.item.selected"
                        primary
                        hide-details
                    ></v-checkbox>
                </td>
                <td class="text-xs-left nowrap">
                  <b class="font-weight-bold primary--text">{{ props.item.name || '-' }}</b>
                </td>
                 <td class="text-xs-left nowrap">
                  <b>{{ props.item.mobile || '-' }}</b>
                </td>
                <td class="text-xs-left nowrap">
                  <b>{{ props.item.prefix || '-' }}</b>
                </td>
              </template>
            </template>
            <template slot="no-data">No Items</template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-flex>
     <v-dialog v-model="dialog" persistent max-width="900">
      <v-card>
        <v-card-title  primary title class="primary white--text">
           <span class="headline">Compose SMS (160 Characters)</span> 
        </v-card-title>
        <v-card-text>
            <v-textarea
                name="input-7-1"
                outlined
                :label="'SMS (' +(160-smsText.length)+' left)'"
                v-model="smsText"
            ></v-textarea>
        </v-card-text>
        <v-card-actions>
        <v-spacer></v-spacer>
          <v-btn primary title class="warning white--text" flat="flat" @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn primary title class="primary white--text" flat="flat" @click="sendSMS">
            SEND
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
import {sendSms} from "../../../services/twilio.js"
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
export default {
  data() {
    return {
      buyerHeader: [
          { text: "Select", value: "name" },
        { text: "Buyer Name", value: "name", sortable: true },
        { text: "Mobile No.", value: "name" },
         { text: "Type", value: "name" },
      ],
      selectedBlock: null,
      selectedDistrict: null,
      selectedState: null,
      selectedTehsil: null,
      selectedVillage: null,
      selectedBuyer:null,
      buyersList: [],
      selectAll : true,
      dialog : false,
      smsText:'',
    };
  },
  created() {
    this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand", "finYear"]),
   
    getBuyers() {
        let buyers = this.buyers.filter(
        (item) =>
          item["brand"] === this.selectedBrand && !!item["mobile"] );
          buyers.map((b,index)=>{
              buyers[index]['prefix'] = 'Buyer'
              buyers[index]['selected'] = true
          })
        let sellers = this.sellers.filter(
        (item) =>
          item["brand"] === this.selectedBrand && !!item["mobile"] );
          sellers.map((b,index)=>{
            sellers[index]['prefix'] = 'Seller'
            sellers[index]['selected'] = true
        })
        this.buyersList = buyers.concat(sellers)   
      return this.buyersList;
    },
  },
  methods: {
      toggleSelect(){
          this.buyersList.map((b,index)=>{
            this.buyersList[index]['selected'] = !this.buyersList[index]['selected'];
          })
      },
      sendSMS(){
        let recp =[];
        this.buyersList.map((b)=>{
          if(b.selected) {
            recp.push("+91"+b.mobile);
          }
        })
        console.log(recp)
        sendSms(["+91"+this.selectedBuyer.mobile],message)
        console.log(this.smsText)
      },
  }
};
</script>

<style >
.theme--light div.select-firm .v-icon {
  color: white;
}
.theme--light div.select-firm .v-label {
  color: white;
}
.theme--light div.select-firm .v-input__slot:before {
  border-color: white !important;
}
div.select-firm .v-select__selection--comma {
  color: white;
}

.theme--light .white-switch {
  margin-top: 25px;
}

.theme--light .white-switch .v-label {
  color: white;
}

.disabledCard {
  background: lightgray;
}

.ist-datepicker .v-icon,
.ist-datepicker .v-label,
.ist-datepicker input {
  color: white !important;
}

.ist-datepicker .v-input__slot:before {
  border-color: white !important;
}

.fl2-table {
  border-radius: 5px;
  font-size: 12px;
  font-weight: normal;
  border: none;
  border-collapse: collapse;
  width: 100%;
  max-width: 100%;
  white-space: nowrap;
  background-color: white;
}

.fl2-table td,
.fl2-table th {
  text-align: center;
  padding: 8px;
}

.fl2-table td {
  border: 1px solid #000000;
  font-size: 12px;
}

.fl2-table thead th {
  color: #ffffff;
  background: #15155d;
  border: 1px solid white;
}

.fl2-table tr:nth-child(even) {
  background: #f8f8f8;
}
</style>



// WEBPACK FOOTER //
// src/components/Informations/SMSBook/SmsBook.vue